<template>
  <div class="social-login-block">
    <div class="social-login-separator my-4">
      <span>{{ t('general.or') }}</span>
    </div>

    <div class="social-login">
      <button
        class="social-login-button social-login-button--google btn btn-primary btn-shadow w-100 border-radius-md"
        @click="handleClickSocialLogin('google')"
      >
        <img src="/icons/google.svg" alt="Google Logo" />
        {{ t('checkout.personalDetails.socialLogin.google') }}
      </button>

      <button
        class="social-login-button social-login-button--facebook btn btn-primary btn-shadow w-100 border-radius-md"
        @click="handleClickSocialLogin('facebook')"
      >
        <img src="/icons/facebook.svg" alt="Facebook Logo" />
        {{ t('checkout.personalDetails.socialLogin.facebook') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
// const { sendSocialLoginAttempt } = useGtm()
const { apiBaseURL } = config.public
const { t } = useI18n()

const props = defineProps<{
  goBack?: boolean
}>()

export type SocialLoginAttemptOrigin = {
  attemptOrigin: string
  goBack: boolean
}

const socialLoginAttemptOrigin = useKftLocalStorage<SocialLoginAttemptOrigin>(
  'social-login-attempt-origin',
  {
    attemptOrigin: '',
    goBack: props.goBack || false,
  }
)

const handleClickSocialLogin = (socialMediaSlug: string) => {
  // sendSocialLoginAttempt(socialMediaSlug)

  socialLoginAttemptOrigin.data.value.attemptOrigin = window.location.pathname
  socialLoginAttemptOrigin.data.value.goBack = props.goBack || false

  setTimeout(() => {
    window.location.href = `${apiBaseURL}/v1/auth/${socialMediaSlug}/redirect`
  }, 200)
}
</script>

<style lang="postcss" scoped>
.social-login {
  @apply flex flex-col gap-4 md:gap-7 md:flex-row;
}

.social-login-separator {
  @apply flex items-center justify-center relative;

  &::before {
    @apply h-[1px] absolute left-0 right-0 top-0 bottom-0 m-auto;

    content: '';
    border-top: 1px dashed #e5e7eb;
  }

  span {
    @apply px-3 bg-white text-sm text-gray-500 inline-flex relative z-1;
  }
}

.social-login-button {
  @apply md:flex-1 h-10 rounded-lg border border-gray-100;
  @apply flex items-center justify-center gap-3.5;
  @apply text-sm font-semibold text-teal-900 transition ease-in-out duration-300;

  box-shadow: 2px 2px 16px 0 rgba(31, 42, 55, 0.04);
  background: #fff;

  img {
    @apply h-6 w-auto;
  }

  &:hover {
    @apply bg-gray-50;
  }
}
</style>
